module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 45 80",
      url: __webpack_public_path__ + "images/js_src_vue/common/sprite.61ac148b.svg#arrow-usage",
      toString: function () {
        return this.url;
      }
    }